module.exports = __webpack_public_path__ + "static/media/filter.8aa9ea9d.jpg";